<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Filtros' | translate}}</ion-title>
  </ion-buttons>
</ion-header>


<ion-content class="list-mini-content">
  <div class="gradient-extendido"></div>
  <div class="remove-border">
    <ion-list>
      <ion-list style="border-bottom: solid 1px #f1f1f1;">
        <ion-radio-group [(ngModel)]="filtro.ordenacao" value="end">
          <ion-item class="list-item">
            <ion-label class="item-title">{{'Ordenar por:' | translate}}</ion-label>
          </ion-item>

          <ion-item>
            <ion-radio value="1" labelPlacement="end" justify="start">{{ 'Data crescente' | translate}}</ion-radio>
          </ion-item>

          <ion-item>
            <ion-radio value="2" labelPlacement="end" justify="start"> {{'Data decrescente' | translate}}</ion-radio>
          </ion-item>
            
        </ion-radio-group>
      </ion-list>

      <ion-item>
        <ion-toggle [enableOnOffLabels]="true" justify="space-between" [(ngModel)]="filtro.publico">
          <h3 class="item-title ">{{'Público' | translate}}</h3>
        </ion-toggle>
      </ion-item>

      <ion-item>
        <ion-toggle [enableOnOffLabels]="true" justify="space-between" [(ngModel)]="filtro.privado">
          <h3 class="item-title">{{'Privado' | translate}}</h3>
        </ion-toggle>
      </ion-item>

      <ion-item>
        <ion-toggle [enableOnOffLabels]="true" justify="space-between" [(ngModel)]="filtro.respondido">
          <h3 class="item-title">{{'Respondido' | translate}}</h3>
        </ion-toggle>
      </ion-item>

      <ion-item>
        <ion-toggle [enableOnOffLabels]="true" justify="space-between" [(ngModel)]="filtro.naoRespondido">
          <h3 class="item-title">{{'Não Respondido' | translate}}</h3>
        </ion-toggle>
      </ion-item>

      <ion-item>
        <ion-toggle [enableOnOffLabels]="true" justify="space-between" [(ngModel)]="filtro.liberado">
          <h3 class="item-title">{{'Liberado' | translate}}</h3>
        </ion-toggle>
      </ion-item>

      <ion-item>
        <ion-toggle [enableOnOffLabels]="true" justify="space-between" [(ngModel)]="filtro.naoLiberado">
          <h3 class="item-title">{{'Não Liberado' | translate}}</h3>
        </ion-toggle>
      </ion-item>

      <ion-item *ngIf="!userProvider.hasConfig(184)">
        <ion-toggle [enableOnOffLabels]="true" justify="space-between" [(ngModel)]="filtro.testemunho" >
          <h3 class="item-title">{{'testemunhos' | nomenclatura | async}}</h3>
        </ion-toggle>
      </ion-item>

      <ion-item *ngIf="!userProvider.hasConfig(184)" style="border-bottom: solid 1px #f1f1f1;">
        <ion-toggle [enableOnOffLabels]="true" justify="space-between" [(ngModel)]="filtro.oracao">
          <h3 class="item-title">{{'oracoes' | nomenclatura | async}}</h3>
        </ion-toggle>
      </ion-item>
      
      <div class="ion-margin-end">
        <prover-datepicker
          [labelName]="'Data Início'"
          [id]="'filtro.dtInicial'"
          [(dateTime)]="filtro.dtInicial"
        ></prover-datepicker>
      </div>

      <div class="ion-margin-end">
        <prover-datepicker
          [labelName]="'Data Fim'"
          [id]="'filtro.dtFinal'"
          [(dateTime)]="filtro.dtFinal"
        ></prover-datepicker>
      </div>
    </ion-list>

    <ion-grid>
      <ion-row>
        <ion-col>
          <div class="pd-5">
            <ion-button (click)="filtrar();" expand="block" class="btn-default">{{'Filtrar' | translate}}</ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>